import { render, staticRenderFns } from "./ResumenMediosTable.vue?vue&type=template&id=07fabd6c"
import script from "./ResumenMediosTable.vue?vue&type=script&lang=js"
export * from "./ResumenMediosTable.vue?vue&type=script&lang=js"
import style0 from "./ResumenMediosTable.vue?vue&type=style&index=0&id=07fabd6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports